import React, {Component} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import DateText from "../../../../common/DateText/DateText";
import "./AccountProductHeader.css";
import EditField from "../../../../common/EditField/EditField";
import Permissions from "../../../../authentication/Permissions";
import AuthorizationService from "../../../../services/authorization-service";

class AccountProductHeader extends Component {

  updateField = (field, value) => {
    let sub = {...this.props.sub}
    sub[field] = value;
    this.props.updateSubscription(sub);
  }

  setUnitId = (value) => {
    this.updateField("unitId", value);
  }
  setE0Number = (value) => {
    this.updateField("e0Number", value);
  }
  setDeveloper = (value) => {
    this.updateField("developer", value);
  }

  render() {
    return (
        <div className="account-products-header">
          <div className="row">
            <div className="col-md-6">
              <div className="row details-row">
                <div className="col-md-3 details-label">App Name</div>
                <div className="col-md-9">{this.props.sub.apigeeAppName}</div>
              </div>
              {<div className="row details-row">
                <div className="col-md-3 details-label">Unit Id</div>
                <div className="col-md-9">
                  <EditField
                      value={this.props.sub.unitId}
                      label="Unit Id"
                      editHandler={this.setUnitId}
                      header="Unit Id"
                      title="Set the Unit Id for the Sub"
                      type="text"
                      canEdit={AuthorizationService.hasPermission(Permissions.subscription.edit) && this.props.sub.isActive && !this.props.sub.isSynchronize}
                  />
                </div>
              </div>}
              <div className="row details-row">
                <div className="col-md-3 details-label">E0 Number</div>
                <div className="col-md-9">
                  <EditField
                      value={this.props.sub.e0Number}
                      label="E0Number"
                      editHandler={this.setE0Number}
                      header="E0Number"
                      title="Set the E0Number for the Sub"
                      type="text"
                      canEdit={AuthorizationService.hasPermission(Permissions.subscription.edit) && this.props.sub.isActive && !this.props.sub.isSynchronize}
                  />
                </div>
              </div>

              <div className="row details-row">
                <div className="col-md-3 details-label">Developer</div>
                <div>
                  <EditField
                      value={this.props.sub.developer}
                      label="Developer Email"
                      editHandler={this.setDeveloper}
                      header="Developer Email"
                      title="Set the Developer Email for the Sub"
                      type="text"
                      canEdit={AuthorizationService.hasPermission(Permissions.subscription.edit) && this.props.sub.isActive}
                  />
                </div>
              </div>

            </div>
            <div className="col-md-6">
              <div className="row details-row">
                <div className="col-md-5 details-label">Created</div>
                <div className="col-md-7">
                  <DateText date={this.props.sub.createdAt}/>
                </div>
              </div>
              <div className="row details-row">
                <div className="col-md-5 details-label">Updated</div>
              <div className="col-md-7">
                <DateText date={this.props.sub.updatedAt}/>
              </div>
            </div>
            <div className="row details-row">
              <div className="col-md-5 details-label">Status</div>
              <div className="col-md-7">
                {this.props.sub.isActive ? "Active" : "Inactive"}
              </div>
            </div>
            <div className="row details-row">
              <div className="col-md-5 details-label">Synced with OM  &nbsp;&nbsp;
                <FontAwesomeIcon
                    icon="info"
                    title="Subscriptions that are synchronized with OM have limited edit capability through the UI."
                    size="lg"
                />
              </div>
              <div className="col-md-7">
                {this.props.sub.isSynchronize ? "Yes" : "No"}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AccountProductHeader;



// WEBPACK FOOTER //
// ./src/accounts/account-product-details/account-api-product-details/components/AccountProductHeader.js